import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Prompt, PromptTag } from './types';

interface PromptState {
  prompts: Prompt[];
  selectedTag: PromptTag | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: PromptState = {
  prompts: [],
  selectedTag: null,
  isLoading: false,
  error: null,
};

export const promptSlice = createSlice({
  name: 'prompt',
  initialState,
  reducers: {
    setPrompts: (state, action: PayloadAction<Prompt[]>) => {
      state.prompts = action.payload;
    },
    setSelectedTag: (state, action: PayloadAction<PromptTag | null>) => {
      state.selectedTag = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setPrompts, setSelectedTag, setLoading, setError } = promptSlice.actions;

export default promptSlice.reducer;
